import { render, staticRenderFns } from "./BookingTemplateItemDimension.vue?vue&type=template&id=552667ea&scoped=true&"
import script from "./BookingTemplateItemDimension.vue?vue&type=script&lang=ts&"
export * from "./BookingTemplateItemDimension.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTemplateItemDimension.vue?vue&type=style&index=0&id=552667ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552667ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem})
